import React from 'react'
import RightSide from '../components/common/rightSide';
import RefundPolicy from '../components/other/refundpolicy';
import PrivacyPolicy from '../components/other/privacyPolicy';


const PrivacyPolicyPage = () => {
    return (
        <>
            <div className='container-fluid mt-2'>
                <div className='row'>
                    {/* <div className='col-md-4'>
                        <RightSide />
                    </div> */}
                    <div className='col-md-12'>
                        <PrivacyPolicy />
                    </div>

                </div>
            </div>
        </>
    )
}

export default PrivacyPolicyPage;